import { handleActions } from "redux-actions";
import { combineReducers } from "redux";
import { interfaceActions } from "../actions";
import * as buttonsActions from "../actions/buttonsActions";
import * as URLs from "../../constants/systemUrls";

const state = {
  drawer: {
    id: null,
    isVisible: false
  },
  view: {
    // showBurger: true, // Показывать ли бургер в меню
    isMenuVisible: false, // Видимо ли меню сейчас, по дефолту false
    showFooter: false, // Показывать нижнюю плашку или нет
    footerContent: {}, // Содержимое нижней плашки
    interfaceBlock: false, // Вывести спиннер и перекрыть интерфейс

    pagination: {
      // поля полностью соответствуют свойствам компонента Pagination из Antd
      current: 1, // номер текущей страницы
      defaultCurrent: 1, // номер страницы, отображаемой по умолчанию
      pageSize: 25, // число итемов на странице
      defaultPageSize: 25, // число иитемов на странице по умолчанию
      hideOnSinglePage: false, // скрывать пагинацию, если страница одна
      pageSizeOptions: ["2", "5", "10", "25", "50"] // варианты для числа итемов на странице
    },

    pageCaption: {
      enabled: false, // Показывать ли сейчас блок с подзаголовком
      captionType: "сrumbs", // Вид подзаголовка
      mainCaption: "Teleportos",
      currentStep: 1, // Текущий шаг
      steps: [
        // Массив с шагами
        { title: "Первый шаг", description: "First-content" },
        { title: "Второй шаг", description: "Second-content" },
        { title: "Третий шаг", description: "Last-content" }
      ],
      breadCrumbs: [
        // Путь для хлебных крошек
        { path: "/" + URLs.CONTROL_PANEL, breadcrumbName: "Панель управления" },
        { path: "/" + URLs.COMPANY, breadcrumbName: "Компании" }
      ]
    }
  },
  buttons: {
    buttons: [],
    isLoading: false,
    err: null
  }
};

const sideDrawer = handleActions(
  {
    [interfaceActions.showSideDrawer]: (state, action) => {
      return {
        ...state,
        drawer: {
          id: action.payload,
          isVisible: true
        }
      };
    },
    [interfaceActions.closeSideDrawer]: (state, action) => {
      return {
        ...state,
        drawer: {
          id: null,
          isVisible: false
        }
      };
    }
  },
  state
);

const elements = handleActions(
  {
    [interfaceActions.showMenu]: state => {
      state.isMenuVisible = !state.isMenuVisible;
      return { ...state };
    },
    [interfaceActions.setCaption]: (state, { payload }) => {
      for (let key in payload) {
        state.pageCaption[key] = payload[key];
      }
      return { ...state };
    },
    [interfaceActions.disableCaption]: state => {
      state.pageCaption.enabled = false;
      return { ...state };
    },
    [interfaceActions.setDefaultPagination]: (state, payload) => {
      for (let key in payload.payload) {
        state[key] = payload.payload[key];
      }
      return { ...state };
    },
    [interfaceActions.blockUI]: state => {
      state.interfaceBlock = true;
      return { ...state };
    },
    [interfaceActions.unblockUI]: state => {
      state.interfaceBlock = false;
      return { ...state };
    }
  },
  state.view
);

const buttons = handleActions(
  {
    [buttonsActions.getProfileButtons]: (state, action) => {
      return { ...state, isLoading: true };
    },
    [buttonsActions.getProfileButtonsSuccess]: (state, action) => {
      let { payload } = action;
      return { ...state, buttons: payload.data, isLoading: false };
    },
    [buttonsActions.getProfileButtonsFailure]: (state, action) => {
      let { payload } = action;
      return { ...state, isLoading: false, err: payload.message };
    }
  },
  state.buttons
);

const Interface = combineReducers({
  sideDrawer,
  elements,
  buttons
});

export { Interface };
